import {
  Card,
  CardContent,
  Grid,
  Select as MuiSelect,
  TextField as MuiTextField,
} from "@mui/material";
import Button from "@mui/material/Button";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import { spacing } from "@mui/system";
import { isEmpty } from "lodash";
import React, { useState } from "react";
import styled from "styled-components";

const Select = styled(MuiSelect)(spacing);
const TextField = styled(MuiTextField)(spacing);

export default (props) => {
  const owner = props.owner;
  const handleClose = props.handleClose;
  const submitOwnerEdit = props.submitOwnerEdit;

  const [editOwnerObj, setEditOwnerObj] = useState({});
  const [editOwnerAddrObj, setEditOwnerAddrObj] = useState({});

  const onOwnerFieldChange = (e) => {
    setEditOwnerObj(
      Object.assign({}, editOwnerObj, { [e.target.name]: e.target.value })
    );
  };

  const onAddrFieldChange = (e) => {
    setEditOwnerAddrObj(
      Object.assign({}, editOwnerAddrObj, { [e.target.name]: e.target.value })
    );
  };

  const action = async () => {
    let editObj = Object.assign(
      {},
      { addressInfo: editOwnerAddrObj },
      { ownerInfo: editOwnerObj }
    );

    await submitOwnerEdit(owner, editObj);
  };

  return (
    <div>
      {isEmpty(owner) ? (
        <div>Loading</div>
      ) : (
        <Card>
          <CardContent>
            {/* PropertyManager Details */}
            <Grid container spacing={2}>
              <h3>Owner Info:</h3>
              <Grid container item spacing={2}>
                <Grid item sm={6} xs={12}>
                  <TextField
                    label="Owner Name"
                    type="text"
                    onChange={onOwnerFieldChange}
                    name="name"
                    defaultValue={owner.name}
                    //required
                    fullWidth
                    variant="outlined"
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Grid>
                <Grid item sm={6} xs={12}>
                  <TextField
                    label="Contact Name"
                    type="text"
                    onChange={onOwnerFieldChange}
                    name="contactName"
                    defaultValue={owner.contactName}
                    //required
                    fullWidth
                    variant="outlined"
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Grid>
                <Grid item sm={6} xs={12}>
                  <TextField
                    label="Address 1"
                    type="text"
                    onChange={onAddrFieldChange}
                    name="address1"
                    defaultValue={owner.address1}
                    //required
                    fullWidth
                    variant="outlined"
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Grid>
                <Grid item sm={6} xs={12}>
                  <TextField
                    label="Address 2"
                    type="text"
                    onChange={onAddrFieldChange}
                    name="address2"
                    defaultValue={owner.address2}
                    //required
                    fullWidth
                    variant="outlined"
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Grid>
                <Grid item sm={6} xs={12}>
                  <TextField
                    label="City"
                    type="text"
                    onChange={onAddrFieldChange}
                    name="city"
                    defaultValue={owner.city}
                    //required
                    fullWidth
                    variant="outlined"
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Grid>
              </Grid>
              <Grid item sm={3} xs={6}>
                <TextField
                  label="State"
                  type="text"
                  onChange={onAddrFieldChange}
                  name="state"
                  defaultValue={owner.state}
                  //required
                  fullWidth
                  variant="outlined"
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>
              <Grid item sm={3} xs={6}>
                <TextField
                  label="Zip"
                  type="text"
                  onChange={onAddrFieldChange}
                  name="zip"
                  defaultValue={owner.zip}
                  //required
                  fullWidth
                  variant="outlined"
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>
              <Grid item sm={3} xs={6}>
                <TextField
                  label="Customer Service Amount"
                  type="number"
                  onChange={onOwnerFieldChange}
                  name="customerServiceAmount"
                  defaultValue={owner.customerServiceAmount}
                  //required
                  fullWidth
                  variant="outlined"
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>
              <Grid item sm={3} xs={6}>
                <TextField
                  label="Distribution Fee Amount"
                  type="number"
                  onChange={onOwnerFieldChange}
                  name="distFeeAmt"
                  defaultValue={owner.distFeeAmt}
                  //required
                  fullWidth
                  variant="outlined"
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>

              <Grid item sm={3} xs={6}>
                <TextField
                  label="Profit Share %"
                  type="number"
                  onChange={onOwnerFieldChange}
                  name="profitSharePercent"
                  defaultValue={owner.profitSharePercent}
                  //required
                  fullWidth
                  variant="outlined"
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>

              <Grid item sm={3} xs={6}>
                <TextField
                  label="Accounting ID"
                  type="text"
                  onChange={onOwnerFieldChange}
                  name="glCode"
                  defaultValue={owner.glCode}
                  //required
                  fullWidth
                  variant="outlined"
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>

              <Grid item sm={12} xs={12}>
                <FormControlLabel
                  control={
                    <Checkbox
                      defaultChecked={owner.active ? true : false}
                      onChange={onOwnerFieldChange}
                      name="active"
                      value="Active"
                    />
                  }
                  label="Active"
                />
              </Grid>

              <h3>Mailing Address Info:</h3>

              <Grid container item spacing={2}>
                <Grid item xs={12} />
                <Grid item sm={6} xs={12}>
                  <TextField
                    label="Mailing Name"
                    type="text"
                    onChange={onOwnerFieldChange}
                    name="mailingName"
                    defaultValue={owner.mailingName}
                    //required
                    fullWidth
                    variant="outlined"
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Grid>
                <Grid item sm={6} xs={12}>
                  <TextField
                    label="Mailing Contact Name"
                    type="text"
                    onChange={onOwnerFieldChange}
                    name="mailingContactName"
                    defaultValue={owner.mailingContactName}
                    //required
                    fullWidth
                    variant="outlined"
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Grid>
              </Grid>
              <Grid container item>
                <Grid item xs={12}>
                  <TextField
                    label="Notes"
                    type="text"
                    onChange={onOwnerFieldChange}
                    defaultValue={owner.notes}
                    name="notes"
                    multiline
                    fullWidth
                    variant="outlined"
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Grid>
              </Grid>

              <Grid container item spacing={2} justify={"flex-end"}>
                <Grid item>
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={() => {
                      action();
                      handleClose();
                    }}
                  >
                    Save
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      )}
    </div>
  );
};
